import Vue from 'vue'

const createNotify = function (type, message) {
    setTimeout(() => Vue.notify({
        group: 'all',
        type: type,
        title: 'EL ARTICULO SE SUBIO CORRECTAMENTE',
        text: message,
        data: {
            close: () => {}
        }
    }), 50)
}

export default createNotify



// WEBPACK FOOTER //
// ./src/utils/Notification.js